import AddPripomienka from './AddPripomienka';

export default AddPripomienka;
